import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getPurchaseOrders } from "api/purchaseOrder.api";
import { gracefulList } from "lib/queryHelpers";

const mapPO = (po) => ({
  id: po.id || po._id,
  poNumber: po.purchaseOrderNumber,
  date: po.issueDate,
  vendorId: po.vendorId,
  vendorName: po.vendorName || "—",
  contact: po.vendorPhone || "",
  email: po.vendorEmail || "",
  netAmount: po.totalAmount ?? 0,
  status: po.status, // draft | pendingApproval | approved | convertedToBill | cancelled
  convertedBillId: po.convertedBillId || null,
  raw: po,
});

export const useGetPurchaseOrders = () => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["purchase-orders"],
    queryFn: gracefulList(() => getPurchaseOrders(), { purchaseOrders: [] }),
    initialData: () => queryClient.getQueryData(["purchase-orders"]),
    select: (data) => (data?.purchaseOrders || []).map(mapPO),
    staleTime: 1000 * 30,
  });
};
